export interface VideoMetaDataProps {
  contentUrl: string;
  description?: string;
  duration?: number;
  embedUrl?: string;
  expires?: string;
  thumbnailUrl?: string;
  uploadDate?: string;
  name?: string;
}
const VideoMetadata = ({
  contentUrl,
  description,
  duration,
  embedUrl,
  expires,
  thumbnailUrl,
  uploadDate,
  name,
}: VideoMetaDataProps) => (
  <div itemScope itemType="https://schema.org/VideoObject">
    <meta itemProp="description" content={description} />
    <meta itemProp="contentUrl" content={contentUrl} />
    <meta itemProp="duration" content={duration ? duration.toString() : ''} />
    <meta itemProp="embedUrl" content={embedUrl} />
    <meta itemProp="expires" content={expires} />
    <meta itemProp="thumbnailUrl" content={thumbnailUrl} />
    <meta itemProp="uploadDate" content={uploadDate} />
    <meta itemProp="name" content={name} />
  </div>
);

export default VideoMetadata;
